import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/lib/auth'
import Dashboard from '@/pages/Dashboard'
import PartsList from '@/pages/PartsList'
import PartForm from '@/pages/PartForm'
import VendorsList from '@/pages/VendorsList'
import VendorForm from '@/pages/VendorForm'
import WantedList from '@/pages/WantedList'
import WantedForm from '@/pages/WantedForm'
import ZonesList from '@/pages/ZonesList'
import BrandsList from '@/pages/BrandsList'
import PostsList from '@/pages/PostsList'
import PostForm from '@/pages/PostForm'
import UsersList from '@/pages/UsersList'
import Login from '@/pages/Login'
import type { ReactNode } from 'react'

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-50">
      <div className="text-slate-500">Loading...</div>
    </div>
  )
}

function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

function AppRoutes() {
  const { user, profile, loading } = useAuth()
  if (loading) return <LoadingScreen />

  function loginElement() {
    if (user && profile) return <Navigate to="/" replace />
    if (user && !profile) return <Navigate to="/" replace />
    return <Login />
  }

  return (
    <Routes>
      <Route path="/login" element={loginElement()} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/parts" element={<ProtectedRoute><PartsList /></ProtectedRoute>} />
      <Route path="/parts/new" element={<ProtectedRoute><PartForm /></ProtectedRoute>} />
      <Route path="/parts/:id" element={<ProtectedRoute><PartForm /></ProtectedRoute>} />
      <Route path="/vendors" element={<ProtectedRoute><VendorsList /></ProtectedRoute>} />
      <Route path="/vendors/new" element={<ProtectedRoute><VendorForm /></ProtectedRoute>} />
      <Route path="/vendors/:id" element={<ProtectedRoute><VendorForm /></ProtectedRoute>} />
      <Route path="/wanted" element={<ProtectedRoute><WantedList /></ProtectedRoute>} />
      <Route path="/wanted/new" element={<ProtectedRoute><WantedForm /></ProtectedRoute>} />
      <Route path="/wanted/:id" element={<ProtectedRoute><WantedForm /></ProtectedRoute>} />
      <Route path="/zones" element={<ProtectedRoute><ZonesList /></ProtectedRoute>} />
      <Route path="/brands" element={<ProtectedRoute><BrandsList /></ProtectedRoute>} />
      <Route path="/blog" element={<ProtectedRoute><PostsList /></ProtectedRoute>} />
      <Route path="/blog/new" element={<ProtectedRoute><PostForm /></ProtectedRoute>} />
      <Route path="/blog/:id" element={<ProtectedRoute><PostForm /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute><UsersList /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
